module.exports = __webpack_public_path__ + "static/img/newfriends.9569ae2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newfriends.png
// module id = GIMS
// module chunks = 136